$('.sc-close').click(function(){
    var wrapper = $(this).parents('.success-screen');
    wrapper.fadeOut();
    wrapper.parent().removeClass('show-success');
});